module.exports = __webpack_public_path__ + "img/dev_phone.6642f172.png";